import get from 'lodash/get';

import * as types from './constants';

const initialState = {
  loading: false,
  error: null,
  applicationId: null,
  validations: null,
  validationError: false,
  applicationType: null,
  isDmtApproval: true,
  applicationData: null,
  applicationDetail: null,
  documents: [],
  breakdown: {},
  valuationType: {},
  evaluationReasons: {},
  selectedProperty: {},
  certificateType: '',
  application: null,
  activeStep: 0,
  property: {},
  ownerShipProperties: null,
};

export default function certificatesReducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.FETCH_CERTIFICATES_APPLICATION:
      return {
        ...state,
        query: get(action.payload, 'query'),
        loading: true,
        error: null,
        applicationId: null,
        validations: null,
        validationError: false,
        applicationType: null,
        isDmtApproval: true,
        applicationData: null,
        application: null,
      };
    case types.FETCH_CERTIFICATES_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        validations: get(action.payload, 'validations') || null,
        validationError: get(action.payload, 'validationError') || null,
        applicationId: get(action.payload, 'applicationId') || null,
        applicationType: get(action.payload, 'applicationType') || null,
        isDmtApproval: get(action.payload, 'isDmtApproval'),
        applicationData: get(action.payload, 'applicationData'),
        application: get(action.payload, 'application'),
        // documents: get(action.payload, 'documents') || [],
        valuationType: get(action.payload, 'valuationType') || [],
        certificateType: get(action.payload, 'certificateType') || null,
        property: get(action.payload, 'property') || null,

        error: null,
      };
    case types.FETCH_CERTIFICATES_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        validations: null,
        applicationId: null,
        validationError: false,
        applicationType: null,
        isDmtApproval: true,
        applicationData: null,
        application: null,
        error: get(action.payload, 'error'),
      };

    case types.DOWNLOAD_CERTIFICATE:
      return {
        ...state,
        query: get(action.payload, 'query'),
        loading: true,
      };
    case types.DOWNLOAD_CERTIFICATE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.DOWNLOAD_CERTIFICATE_ERROR:
      return {
        ...state,
        loading: false,
        error: get(action.payload, 'error'),
      };

    case types.FETCH_CERTIFICATES_APPLICATION_DETAIL:
      return {
        ...state,
        query: get(action.payload, 'query'),
        loading: true,
        error: null,
        applicationId: null,
        applicationData: null,
        application: null,
      };
    case types.FETCH_CERTIFICATES_APPLICATION_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        applicationId: get(action.payload, 'applicationId') || null,
        applicationDetail: get(action.payload, 'applicationDetail'),
        error: null,
      };
    case types.FETCH_CERTIFICATES_APPLICATION_DETAIL_ERROR:
      return {
        ...state,
        loading: false,
        applicationId: null,
        applicationDetail: null,
        error: get(action.payload, 'error'),
      };
    case types.VALIDATE_CERIFICATES:
      return {
        ...state,
        query: get(action.payload, 'query'),
        error: null,
        loading: true,
      };
    case types.VALIDATE_CERIFICATES_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
      };
    case types.VALIDATE_CERIFICATES_ERROR:
      return {
        ...state,
        loading: false,
        error: get(action.payload, 'error'),
      };
    case types.UPDATE_VALUATION_TYPE:
      return {
        ...state,
        error: null,
        valuationType: {
          ...state.valuationType,
          ...action.payload,
        },
      };
    case types.ACTION_START:
      return {
        ...state,
        loading: true,
        error: undefined,
      };
    case types.ACTION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.ACTION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.UPDATE_CERTIFICATE_TYPE:
      return {
        ...state,
        certificateType: get(action.payload, 'certificateType') || null,
      };
    case types.CERTIFICATE_CANCEL_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.CERTIFICATE_CANCEL_APPLICATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case types.CERTIFICATE_CANCEL_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.CHANGE_STEP:
      return {
        ...state,
        loading: false,
        activeStep: get(action.payload, 'step'),
      };
    case types.PAYMENT_BREAKDOWN_SUCCESS:
      return {
        ...state,
        loading: false,
        application: { ...state.application, paymentBreakDown: get(action.payload, 'breakdown', {}) },
        breakdown: get(action.payload, 'breakdown', {}),
      };
    case types.SET_PROPERTY_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedProperty: action.payload,
      };
    case types.UPLOAD_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        documents: [...state.documents, action.payload],
      };
    case types.DELETE_DOCUMENT_SUCCESS: {
      const newDocs = state.documents.filter(file => file.id !== action.payload?.fileId);
      return {
        ...state,
        loading: false,
        error: null,
        documents: newDocs,
      };
    }
    case types.GET_DOCUMENTS_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
        documents: action.payload,
      };
    }
    case types.SET_EVALUATION_REASONS: {
      return {
        ...state,
        loading: false,
        error: null,
        evaluationReasons: action.payload,
      };
    }
    case types.UPDATE_CERTIFICATE_STATE:
      return {
        ...state,
        ...action.payload,
      };
    case types.CERTIFICATES_CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };
    case types.CERTIFICATES_LOADING:
      return {
        ...state,
        loading: true,
      };
    case types.CERTIFICATES_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.CERTIFICATES_ERROR:
      return {
        ...state,
        loading: false,
        error: get(action, 'payload', null),
      };
    case types.CERTIFICATES_FETCH_DOCUMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        documents: get(action.payload, 'documents', []),
      };
    case types.CERTIFICATES_FETCH_OWNRESHIP_PROPERTIES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        ownerShipProperties: get(action.payload, 'ownerShipProperties', null),
      };

    default:
      return state;
  }
}
